import routes from './open-shop.routes';

export default angular.module('cui.openShop', ['ui.router'])
  .config(routes);



// WEBPACK FOOTER //
// ./source/client/pages/open-shop/index.js